
import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/cce2e63cd0f672379310f0cd298ecb70.jpg"
          alt="AI Strategy visualization"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B0D10]/70 via-[#0B0D10]/50 to-[#0B0D10]"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8 text-center w-full pt-20">
        <p className="text-sm tracking-[0.3em] uppercase text-[#C9CDD3]/60 mb-6 opacity-0 animate-fade-up">
          AI Business Partners
        </p>
        <h1 className="text-5xl md:text-6xl lg:text-[80px] font-bold text-[#F5F7FA] leading-[1.05] mb-8 tracking-tight opacity-0 animate-fade-up-delay-1">
          AI Strategy for<br />Organizations That Can't<br />Afford Guesswork
        </h1>

        <p className="text-lg md:text-xl text-[#F5F7FA]/70 max-w-3xl mx-auto mb-14 leading-relaxed font-light opacity-0 animate-fade-up-delay-2">
          We help healthcare operators, commercial real estate firms, consulting leaders, and private equity teams identify where AI delivers measurable business value — then implement it with precision.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-5 opacity-0 animate-fade-up-delay-3">
          <a
            href="#consultation"
            className="px-10 py-4 bg-[#F5F7FA] text-[#0B0D10] text-sm font-semibold rounded-full hover:bg-white transition-all cursor-pointer whitespace-nowrap shadow-2xl hover:shadow-white/10 hover:scale-105 duration-300"
          >
            Request an AI Audit
          </a>
          <a
            href="#approach"
            className="px-10 py-4 bg-[#F5F7FA]/10 backdrop-blur-sm text-[#F5F7FA] text-sm font-medium rounded-full hover:bg-[#F5F7FA]/20 transition-all cursor-pointer whitespace-nowrap border border-[#F5F7FA]/20 duration-300"
          >
            Explore Our Approach
          </a>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2">
        <div className="w-6 h-10 border-2 border-[#C9CDD3]/30 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1.5 h-3 bg-[#C9CDD3]/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}
